import i18next from 'i18next';

export const defaultTranslation = (
  value: any,
  property: string
): string => {
  const lang = i18next.language;
  const translations = value?.translations;

  // Try current language
  if (translations?.[lang]?.[property]) {
    return translations[lang][property];
  }

  // Fallback to Arabic
  if (translations?.['ar']?.[property]) {
    return translations['ar'][property];
  }

  // Fallback to undefined
  return "-";
};
